<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.training.menu"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.training.list.title"></app-i18n>
      </h1>

      <app-training-list-toolbar></app-training-list-toolbar>
      <app-training-list-filter></app-training-list-filter>
      <app-training-list-table></app-training-list-table>
    </div>
  </div>
</template>

<script>
import TrainingListFilter from '@modules/training/components/training-list-filter.vue';
import TrainingListTable from '@modules/training/components/training-list-table.vue';
import TrainingListToolbar from '@modules/training/components/training-list-toolbar.vue';

export default {
  name: 'app-training-list-page',

  components: {
    [TrainingListFilter.name]: TrainingListFilter,
    [TrainingListTable.name]: TrainingListTable,
    [TrainingListToolbar.name]: TrainingListToolbar,
  },
};
</script>

<style>
</style>
